import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Restore scroll position on navigation.
 *
 * React Router keeps the scroll offset when the route changes, which means
 * clicking a project from halfway down the index opens its detail page already
 * scrolled past the cover image. This component resets to the top on a path
 * change, and scrolls to the matching element when the URL carries a hash
 * (used by the header's "Studio" / "Usluge" / "Kontakt" links).
 *
 * Renders nothing.
 *
 * @returns {null}
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // The target section may mount in the same commit as this effect, so
      // defer the lookup by a frame before giving up on it.
      const scrollToHashTarget = () => {
        const target = document.querySelector(hash);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      const frameId = window.requestAnimationFrame(scrollToHashTarget);
      return () => window.cancelAnimationFrame(frameId);
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
